// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import psolEntity from './entities/psol.json';
import psolMenu from '../pages/psol/menu.json';
import psolFullForm from '../pages/psol/forms/full.json';
import psolContextForm from '../pages/psol/forms/context.json';
import psolMiniForm from '../pages/psol/forms/mini.json';
import psolLookupForm from '../pages/psol/forms/lookup.json';
import psolTableView from '../pages/psol/views/table.json';
import psolStagesView from '../pages/psol/views/stages.json';
import psolCardsView from '../pages/psol/views/cards.json';
import psolInlineView from '../pages/psol/views/inline.json';
import psolBacklogView from '../pages/psol/views/backlog.json';
import psolSplitView from '../pages/psol/views/split.json';
import psolCalendarView from '../pages/psol/views/calendar.json';
import psolDashboardView from '../pages/psol/views/dashboard.json';

/** Тип запису «Рішення» зі сторінками пакета: меню, форми та подання з pages/psol/. */
export const psolDefinition: IRecordTypeDefinition = {
  ...psolEntity,
  views: assembleViewSet({
      table: psolTableView,
      stages: psolStagesView,
      cards: psolCardsView,
      inline: psolInlineView,
      backlog: psolBacklogView,
      split: psolSplitView,
      calendar: psolCalendarView,
      dashboard: psolDashboardView,
  }),
  form: psolFullForm,
  forms: { full: psolFullForm, context: psolContextForm, mini: psolMiniForm, lookup: psolLookupForm },
  menu: psolMenu,
} as IRecordTypeDefinition;
